/**
 * @file   src\pages\Messaging.js
 * @brief  This file is responsible for handling messaging/chat screen.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useSelector } from "react-redux";
import MessageLeftSection from "../components/Messages/MessageLeftSection";
import { decodeParam, getLocalStorage, getUserType, loggedInUser } from "../helpers/common";
import { USER_INFO_KEY, USER_TYPE_AGENT } from "../constants/common";
import MessagesRightSection from "../components/Messages/MessagesRightSection";
import { loginOrSignUp } from "../helpers/message";
import { getIntroductionDetaisById } from "../services/introductionService";
import IntroDetails from "../components/Messages/IntroDetails";
import AgentProfileViewModal from "../components/Introduction/AgentProfileViewModal";
import SelectDropDown from "../components/Common/SelectDropDown";
import {
  useNavigate,
  useSearchParams,
  useParams,
  useLocation,
} from "react-router-dom";
import { pageURLs } from "@/constants";
import { use } from "react";
import DirectMessages from "./v2/DirectMessaging";
import { PageWrapper } from "@/components/PageWrapper";
import { useMLSAgentAtGitchaHomeRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";

const Messaging = (props) => {

  const navigate = useNavigate();

  const sessionData = getLocalStorage(USER_INFO_KEY);
  //user's own info
  const userId = _.get(sessionData, "userInfo.userId", "");
  const [selectedIntroductionId, setSelectedIntroductionId] = useState(0);
  const [selectedData, setSelectedData] = useState("");
  const [showChatOnMobile, setShowChatOnMobile] = useState(false);
  const [filter, setFilter] = useState("all");
  const userDetails = loggedInUser();
  const [showViewIntroductionModal, setViewIntroductionModal] = useState(false);
  const handleIntroDetailModal = (modalState) =>
    setViewIntroductionModal(modalState);
  const [introDetails, setIntroDetails] = useState([]);
  const [showProfileModal, setProfileModal] = useState(false);
  const ProfileModalClose = () => setProfileModal(false);
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [isFromMessage, setIsFromMessage] = useState(false);
  const [filterList, setFilterList] = useState([]);

  const [message, setMessages] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [introIdFromURL, setIntroIDFromURL] = useState(
    searchParams.get("Id") ? decodeParam(searchParams.get("Id")) : null,
  );

  const [userDeleted, setUserDeleted] = useState(false);
  const params = useParams();

  const chatMessages = useSelector((state) => state.unreadCount.chatMessages);
  const location = useLocation();
  const introductionsArray = location.state?.introductionsArray || [];
  const fromDM = location.state?.fromDM;

  useEffect(() => {
    let email = _.get(userDetails, "userInfo.email", null);
    let login = loginOrSignUp(email);

    if (!login) {
      navigate(pageURLs.home);
    }
  }, []);
  const handleWantAdSelection = async (msgData) => {
    if (msgData?.introductionId) {
      setSelectedIntroductionId(msgData?.introductionId);
      setSelectedData(msgData);
      setIntroIDFromURL(null);
      setShowChatOnMobile(true);
    }
  };

  const handleFilter = (e) => {
    setFilter(e.value);
  };

  const handleFilterValue = (value) => {
    if (filterList && value) {
      const filterValue = filterList.filter(function (lst) {
        return lst.value === value;
      });
      return filterValue;
    }
    return null;
  };

  useEffect(() => {
    let fetchedMessages = chatMessages?.payload;
    let orderd = [];
    if (fetchedMessages) {
      let assignedToMe = fetchedMessages?.filter(
        (item) =>
          item.wantAdCreatedId == userId &&
          item.isaccepted == true &&
          item.isdeleted == false,
      );
      let assignedByMe = fetchedMessages?.filter(
        (item) =>
          item.inventroyCreatedId == userId &&
          item.isaccepted == true &&
          item.isdeleted == false,
      );

      orderd = [...assignedToMe, ...assignedByMe];

      let allCountLabel =
        orderd && orderd.length > 0
          ? "All conversations (" + orderd.length + ")"
          : "All conversations";
      let sentByMeCountLabel =
        assignedByMe && assignedByMe.length > 0
          ? "Introductions sent (" + assignedByMe.length + ")"
          : "Introductions sent";
      let sentToMeCountLabel =
        assignedToMe && assignedToMe.length > 0
          ? "Introduced to me (" + assignedToMe.length + ")"
          : "Introduced to me";

      const options = [
        { value: "all", label: allCountLabel },
        { value: "intro_sent", label: sentByMeCountLabel },
        { value: "intro_to_me", label: sentToMeCountLabel },
      ];
      setFilterList(options);

      if (filter == "intro_to_me") {
        const doEmptyAction = assignedToMe.every((o) => o.createdat);
        if (doEmptyAction) {
          orderd = assignedToMe.sort((a, b) => b.createdat - a.createdat);
          setMessages(orderd);
        }
      } else if (filter == "intro_sent") {
        const doEmptyAction = assignedByMe.every((o) => o.createdat);
        if (doEmptyAction) {
          orderd = assignedByMe.sort((a, b) => b.createdat - a.createdat);
          setMessages(orderd);
        }
      } else {
        const doEmptyAction = orderd.every((o) => o.createdat);
        if (doEmptyAction) {
          let orderdNew = orderd.sort((a, b) => b.createdat - a.createdat);
          setMessages(orderdNew);
        }
      }
    } else {
      const options = [
        { value: "all", label: 0 },
        { value: "intro_sent", label: 0 },
        { value: "intro_to_me", label: 0 },
      ];
      setFilterList(options);
      setMessages([]);
      setSelectedData(null);
      setSelectedIntroductionId(null);
    }
  }, [chatMessages, filter]);
  /**
   * To get introduction details
   * @param {*} introductionId
   */
  const getIntroductionDetails = async (introductionId) => {
    if (introductionId) {
      await getIntroductionDetaisById(introductionId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setIntroDetails(responseResult[0]);
            handleIntroDetailModal(true);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  const ViewProfile = (agentId, isFromMessageScreen = false) => {
    handleIntroDetailModal(false);
    setIsFromMessage(isFromMessageScreen);
    setSelectedUserId(agentId);
    setProfileModal(true);
  };

  const closeAgentModal = (isFromMessage) => {
    if (!isFromMessage) {
      handleIntroDetailModal(true);
    }
    setProfileModal(false);
  };

  useMLSAgentAtGitchaHomeRedirect();

  return (
    <>
      <PageWrapper>
        <div className="m-0">
          <div className="main-content p-0 agent-no-login-content">
            <div className="msg-tab">
              <Tabs
                defaultActiveKey="messages"
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={(key) => {
                  if (key === "direct-message") {
                    navigate("/direct-messages");
                  } else {
                    navigate("/messages");
                  }
                }}
              >
                <Tab eventKey="messages" title="Introduction Messages">
                  <div className={`row msg-height ${showChatOnMobile ? "mobile-chat-active" : ""}`}>
                    <div className="col-12 col-md-6 pe-md-3 col-lg-4 pe-lg-3 col-xl-4 pe-xl-2 mb-4 mb-sm-4 mb-md-0 msg-left-col">
                      <div className="ad-strengthen-wrap strengthen-adjust-wrap mh-490 pe-0 ps-0 pt-0 pb-2">
                        <div className="messaging-top-header pb-12 pl-16 pr-16 pt-4">
                          <h3>Messages</h3>
                          {!introductionsArray.length > 0 && !fromDM && (
                            <div className="messaging-select-wrap">
                              <SelectDropDown
                                id="multi3444"
                                name="colors33"
                                options={filterList}
                                className="basic-single-inventory bg-color-fix message-custom-width mb-0"
                                classNamePrefix="select"
                                placeholder="Select"
                                defaultValue={filterList[0]}
                                value={handleFilterValue(filter)}
                                onChange={(e) => {
                                  handleFilter(e);
                                }}
                                styles={{
                                  dropdownIndicator: (provided, state) => ({
                                    ...provided,
                                    transform:
                                      state.selectProps.menuIsOpen &&
                                      "rotate(180deg)",
                                  }),
                                }}
                                errorClass="error-msg error-msg-height"
                              />
                            </div>
                          )}
                        </div>

                        <MessageLeftSection
                          userId={userId}
                          messages={message}
                          selectedIntroductionId={selectedIntroductionId}
                          handleWantAdSelection={(msgData) => {
                            handleWantAdSelection(msgData);
                          }}
                          introIdFromURL={introIdFromURL}
                          introductionsArray={introductionsArray}
                          fromDM={fromDM}
                        />
                      </div>
                    </div>
                    {(selectedData?.introductionId || introductionsArray.length > 0) && (
                      <MessagesRightSection
                        selectedId={selectedIntroductionId}
                        userId={userId}
                        selectedData={selectedData}
                        getIntroductionDetails={(IntroductionId) => {
                          getIntroductionDetails(IntroductionId);
                        }}
                        ViewProfileModal={(agentId) => {
                          ViewProfile(agentId, true);
                        }}
                        userDeletedUpdate={(deleted) => {
                          setUserDeleted(deleted);
                        }}
                        introductionsArray={introductionsArray}
                        fromDM={fromDM}
                        onMobileBack={() => {
                          setShowChatOnMobile(false);
                          setSelectedData(null);
                          setSelectedIntroductionId(null);
                        }}
                      />
                    )}
                  </div>
                </Tab>
                <Tab eventKey="direct-message" title="Direct Messages">
                  <DirectMessages />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </PageWrapper>
      <IntroDetails
        details={introDetails}
        show={showViewIntroductionModal}
        onHide={handleIntroDetailModal}
        ViewProfileModal={(agentId) => {
          ViewProfile(agentId);
        }}
        userDeleted={userDeleted}
      />

      <AgentProfileViewModal
        show={showProfileModal}
        onHide={ProfileModalClose}
        userId={selectedUserId}
        isFromMessage={isFromMessage}
        onClose={(isFromMessage) => {
          closeAgentModal(isFromMessage);
        }}
      />
    </>
  );
};

export default Messaging;
